// inject this into component
import { createGlobalStyle } from "styled-components"
import "./global.scss"
import { defaultTheme, MapSpotTheme } from "./themes"

const theme = defaultTheme

export const outsideBorderThickness = 8

export const GlobalStyle = createGlobalStyle<{ theme: MapSpotTheme }>`

  html, body, #root {
    margin: 0;
    font-family: ${({ theme }) => theme.fontFamily || "'Electrolize', 'Exo 2', sans-serif"}, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.white};
  }

  ${({ theme }) => theme.headingFontFamily && `
    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
      font-family: ${theme.headingFontFamily}, sans-serif;
    }
  `}

  .grecaptcha-badge {
    visibility: hidden !important;
  }

  // mapbox popup
  .mapboxgl-popup-anchor-bottom {
    max-width: unset;
    &.mapboxgl-popup-tip {
      border-top-color: ${({ theme }) => theme.colors.background};
    }
  }
  .mapboxgl-popup-anchor-left {
    border-color: ${({ theme }) => theme.colors.background};
  }

  .mapboxgl-popup-content {
    padding: 0;
    background-color: ${({ theme }) => theme.colors.background};
  }
  
  .popup-hover {
    padding: 5px 10px;
  }

  a {
    color: ${({ theme }) => theme.colors.white};
    text-decoration-color: ${({ theme }) => theme.colors.white};
  }
  
  .h1 {
    font-size: 2.5rem;
  }
  .h2 {
    font-size: 2rem;
  }
  .h3 {
    font-size: 1.5rem;
  }
  .h4 {
    font-size: 1.25rem;
  }
  .h5 {
    font-size: 1rem;
  }
  .h6 {
    font-size: 0.75rem;
  }
  
  b, strong {
    font-weight: bold;
  }

  // Scrollbar
  // https://codepen.io/GhostRider/pen/oNvoNv
  //.scrollbar-1::-webkit-scrollbar-track {
  //  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  //  background-color: #F5F5F5;
  //}
  //
  //.scrollbar-1::-webkit-scrollbar {
  //  width: 10px;
  //  background-color: #F5F5F5;
  //}
  //
  //.scrollbar-1::-webkit-scrollbar-thumb {
  //  background-color: #000000;
  //  border: 2px solid #555555;
  //}

  .scrollbar-wrap {
    div {
      ::-webkit-scrollbar {
        width: 5px;
        //background-color: #F5F5F5;
        background-color: transparent;
      }
      ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        //background-color: #F5F5F5;
        background-color: transparent;
      }
      ::-webkit-scrollbar-thumb {
         background-color: ${({ theme }) => theme.colors.primary};

         background-image: -webkit-gradient(linear, 0 0, 0 100%,
         color-stop(.5, rgba(255, 255, 255, .2)),
         color-stop(.5, transparent), to(transparent));
       }
    }
  }

  .scrollbar-2 {
    ::-webkit-scrollbar {
      width: 5px;
      background-color: transparent;
    }
    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.colors.primary};

      background-image: -webkit-gradient(linear, 0 0, 0 100%,
      color-stop(.5, rgba(255, 255, 255, .2)),
      color-stop(.5, transparent), to(transparent));
    }
  }
`

export default theme

